<script lang="ts">
import TitleMedallion from '@/components/TitleMedallion.vue'
import { useDesignStore } from '@/stores/designStore.ts'
import { useManualStore } from '@/stores/manualStore.ts'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import RenderSpecialPage from '@/components/Manual/Rules/Special Reference Pages/RenderSpecialPage.vue'

export default {
  props: ['page'],
  setup(props, context) {
    const manualStore = useManualStore()
    const { getRules, rulesReference } = storeToRefs(manualStore)
    const designStore = useDesignStore()
    function scrollbarColor() {
      let sec = designStore.secondaryTheme
      let prim = designStore.primaryTheme
      return sec + ' ' + prim
    }

    const doc = computed(() => {
      return formatHTML(
        props.page
          ? rulesReference.value[props.page].document
          : `<div>Oops! I don't know that word.  Maybe try typing it in a different way.  If you're Brand new and looking for help,  the New Player Guide is a great place to start! If you can't find a specific term here, the Manual might be your best bet.</div>`
      )
    })
    const ruleRef = computed(() => {
      return props.page
        ? rulesReference.value[props.page]
        : {
            title: 'Sorry! Nothing Found :(',
            document: `<div>Oops! I don't know that word.  Try trying it in a different way maybe.  If you're Brand new and looking for help,  the New Player Guide is a great place to start!</div>`,
            type: 'html'
          }
    })

    function formatHTML(description: string) {
      let sections = description.split('\\n')
      let ret
      if (sections.length === 1) {
        sections = description.split('\n*')
      }

      if (sections.length === 1) {
        sections = description.split('\n')
        if (sections.length === 1) return '<div>' + description + '</div>'
        else {
          ret = '<div style="margin-bottom: .25rem">'
          sections.forEach((s) => {
            if (s === '') {
              ret += '<div style="padding: .5rem"></div>'
            }
            ret += '<div style=" margin-bottom: .25rem;list-style-type:none;">' + s + '</div>'
          })
          ret += '</div>'
        }
      } else {
        let subsections = sections[0].split('\n')
        if (sections.length === 1)
          ret = '<div style="margin-bottom: .25rem">' + sections[0] + '</div>'
        else {
          ret = '<div style="margin-bottom: .25rem">'
          subsections.forEach((s) => {
            if (s === '' || s === ' ') {
              ret += '<div style="padding: .5rem"></div>'
            } else if (s === undefined) {
              ret += 'select'
            } else {
              ret += '<div style=" margin-bottom: .25rem;list-style-type:none;">' + s + '</div>'
            }
          })
          ret += '</div>'
        }
        sections.shift()
        sections.forEach((s) => {
          if (s.length > 3) {
            ret +=
              '<li style="margin-left:.5rem; padding-left: 1rem; margin-bottom: .25rem;list-style-type:none;text-indent: -1rem ;">' +
              '❖ ' +
              s +
              '</li>'
          }
        })
      }
      return ret
    }
    const search = ref('')

    const decorScale = computed(() => {
      return window.innerWidth / 650
    })
    return {
      props,
      designStore,
      scrollbarColor,
      getRules,
      rulesReference,
      search,
      formatHTML,

      doc,

      decorScale,
      ruleRef
    }
  },
  components: {
    TitleMedallion,
    RenderSpecialPage
  }
}
</script>

<template>
  <div class="refernceContainer">
    <div
      :style="{ scrollbarColor: scrollbarColor(), background: designStore.sidebarBacking }"
      style="height: 100%; max-height: calc(100vh - 16.5rem); overflow-y: scroll; width: 100%"
    >
      <div :style="{ background: designStore.inputBacking, color: designStore.inputText }">
        <title-medallion
          :title="page ? page : `Sorry! I couldn't find a match :(`"
          :color="designStore.inputText"
        ></title-medallion>
        <div v-if="ruleRef?.type === 'html'">
          <div style="display: flex">
            <div
              style="padding: 1rem; max-width: 90rem; flex-grow: 1"
              v-html="doc"
              :style="{ background: designStore.inputBacking }"
            ></div>
          </div>
        </div>
        <div v-if="ruleRef?.type === 'special'">
          <RenderSpecialPage :title="ruleRef.title"></RenderSpecialPage>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.tag {
  width: 12rem;
  margin: 0.25rem;
}
.tagContainer {
  display: block;
}

@media (max-width: 800px) {
  .tagContainer {
    position: absolute;
    z-index: 5;
    display: none;
  }
  .displayItPlease {
    display: block;
    position: absolute;
    z-index: 5;
  }
}
.largeDecor {
  display: none;
}
@media (min-width: 2000px) {
  .largeDecor {
    display: block;
  }
}
.refernceContainer {
  display: flex;
  justify-content: center;
  width: 100%;
}
@media (min-width: 1900px) {
  .refernceContainer {
    width: 90rem;
  }
}
</style>
